// extracted by mini-css-extract-plugin
export var dropdownButton = "_17-0";
export var fullWidthDropdownButton = "_17-1";
export var icon = "_17-3";
export var iconPlaceholder = "_17-2";
export var menuItemRow = "_17-9";
export var separator = "_17-e";
export var shortcutContainer = "_17-7";
export var shortcutContainerFilled = "_17-8";
export var shortcutIconLg = "_17-6";
export var shortcutIconMd = "_17-5";
export var shortcutIconSm = "_17-4";
export var submenuChevron = "_17-d";
export var submenuDropdown = "_17-a";
export var submenuTriggerRow = "_17-b";
export var submenuTriggerRowOpen = "_17-c";